import { render, staticRenderFns } from "./BracketCompetitorList.vue?vue&type=template&id=6991772e&scoped=true&"
import script from "./BracketCompetitorList.vue?vue&type=script&lang=js&"
export * from "./BracketCompetitorList.vue?vue&type=script&lang=js&"
import style0 from "./BracketCompetitorList.vue?vue&type=style&index=0&id=6991772e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6991772e",
  null
  
)

export default component.exports